import {
  DisablePaypalIntegrationRequestParams,
  DisablePaypalIntegrationResponse,
  FetchPaypalOnboardingLinkRequestParams,
  FetchPaypalOnboardingLinkResponse,
  FetchShorePayOnlineOnboardingLinkRequestParams,
  FetchShorePayOnlineOnboardingLinkResponse,
  FetchSubPaymentMethodsRequestParams,
  FetchSubPaymentMethodsResponse,
  ToggleSubPaymentMethodRequestParams,
  ToggleSubPaymentMethodResponse,
} from '../types';

export async function fetchPaypalOnboardingLink({
  apiClient,
  merchantId,
}: FetchPaypalOnboardingLinkRequestParams): Promise<FetchPaypalOnboardingLinkResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.signupLink.create(payload);
}

export async function disablePaypalIntegration({
  apiClient,
  merchantId,
}: DisablePaypalIntegrationRequestParams): Promise<DisablePaypalIntegrationResponse> {
  const payload = { merchant: { id: merchantId } };
  return apiClient.payPal.deactivate.create(payload);
}

export async function fetchShorePayOnlineOnboardingLink({
  apiClient,
  company,
  taxId,
  merchantId,
}: FetchShorePayOnlineOnboardingLinkRequestParams): Promise<FetchShorePayOnlineOnboardingLinkResponse> {
  const payload = {
    source: company,
    merchant_id: merchantId,
    ...(taxId && { tax_number: taxId }),
  };
  return apiClient.shorepayV1.initiateAccountCreation(payload);
}

// TODO: Replace with real API call when backend is ready.
export async function fetchSubPaymentMethods(
  _params: FetchSubPaymentMethodsRequestParams
): Promise<FetchSubPaymentMethodsResponse> {
  await new Promise((resolve) => setTimeout(resolve, 2000));

  return {
    data: [
      {
        name: 'credit_card',
        displayName: 'Credit Card Payment',
        enabled: true,
        icons: ['visa', 'mastercard', 'maestro', 'amex', 'cb'],
      },
      {
        name: 'apple_pay',
        displayName: 'Apple Pay',
        enabled: true,
        icons: ['apple_pay'],
      },
      {
        name: 'google_pay',
        displayName: 'Google Pay',
        enabled: true,
        icons: ['google_pay'],
      },
      {
        name: 'klarna',
        displayName: 'Klarna',
        enabled: true,
        icons: ['klarna'],
      },
    ],
  };
}

// TODO: Replace with real API call when backend is ready.
export async function toggleSubPaymentMethod({
  subPaymentMethodName,
  enabled,
}: ToggleSubPaymentMethodRequestParams): Promise<ToggleSubPaymentMethodResponse> {
  await new Promise((resolve) => setTimeout(resolve, 2000));

  return {
    data: {
      name: subPaymentMethodName,
      displayName: subPaymentMethodName.replace(/_/g, ' '),
      enabled,
      icons: [],
    },
  };
}
